import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { Notice, NoticeListParams } from '~/features/notice/types/notice.type';

/**
 * 공지사항 목록 조회
 * @description 등록된 공지사항 목록을 조회합니다
 * @endpoint GET /admin/notices
 * @param params - 조회 파라미터
 * @returns 공지사항 목록 및 페이지네이션 정보
 */
export function getNoticeListApi(params?: NoticeListParams) {
  return axiosInstance.get<PaginatedApiResponse<Notice>>('/admin/notices', { params });
}
